import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';

import { DupontThemeProvider, DupontToastProvider } from 'packages/ui-components';
import { setLoggerConfig } from 'packages/ui-components/utils/DupontLogger/logger.conf';
import { DupontWaterTheme } from 'packages/ui-styles';

import ChatbotMaintenance from 'containers/ChabotMaintenance';

import Chatbot from './Chatbot';
//import reportWebVitals from './reportWebVitals';
import ChatbotStore from './store';

import './index.scss';

setLoggerConfig({ isLogToConsole: process.env.REACT_APP_ENVIRONMENT !== 'prod' });

const isAppUnderMaintenace = process.env.REACT_APP_UNDER_MAINTENANCE === 'true';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={ChatbotStore}>
    <Router>
      <StyledEngineProvider injectFirst>
        <DupontToastProvider>
          <DupontThemeProvider theme={DupontWaterTheme}>
            <CssBaseline />
            {isAppUnderMaintenace ? <ChatbotMaintenance /> : <Chatbot />}
          </DupontThemeProvider>
        </DupontToastProvider>
      </StyledEngineProvider>
    </Router>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
//reportWebVitals(console.log);
